import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import styled from "@emotion/styled";

const GenericModal = ({ isOpen, onClose, children, bg = "#fff" }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <ModalOverlay>
      <ModalWrapper bg={bg}>
        <CloseButton onClick={() => onClose()}>
          <svg
            width="32"
            height="33"
            viewBox="0 0 32 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.8">
              <rect y="0.5" width="32" height="32" rx="16" fill="#212543" />
              <path
                d="M20.793 12.7695L17.043 16.5195L20.7617 20.2383C21.0742 20.5195 21.0742 20.9883 20.7617 21.2695C20.4805 21.582 20.0117 21.582 19.7305 21.2695L15.9805 17.5508L12.2617 21.2695C11.9805 21.582 11.5117 21.582 11.2305 21.2695C10.918 20.9883 10.918 20.5195 11.2305 20.207L14.9492 16.4883L11.2305 12.7695C10.918 12.4883 10.918 12.0195 11.2305 11.707C11.5117 11.4258 11.9805 11.4258 12.293 11.707L16.0117 15.457L19.7305 11.7383C20.0117 11.4258 20.4805 11.4258 20.793 11.7383C21.0742 12.0195 21.0742 12.4883 20.793 12.7695Z"
                fill="#F1F5F9"
              />
            </g>
          </svg>
        </CloseButton>
        <ModalContent>{children}</ModalContent>
      </ModalWrapper>
    </ModalOverlay>,
    document.getElementById("modal-root")
  );
};

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalWrapper = styled.div`
  background: ${({ bg }) => bg || "#fff"};
  border-radius: 8px;
  max-width: 100%;
  z-index: 1001;
  position: relative;
  border-radius: 32px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
`;

const ModalContent = styled.div`
  text-align: center;
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
  word-break: break-word;
  box-sizing: border-box;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 9999;
`;

export default GenericModal;
